import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetNewDnpLinkInput } from './GetNewDnpLinkInput';
import { GetNewDnpLinkOutput } from './GetNewDnpLinkOutput';

export class GetNewDnpLinkService extends HttpServiceBase {

    handle = (input: GetNewDnpLinkInput): Promise<Result<GetNewDnpLinkOutput>|null> => {
        const promise = this.http.post<Result<GetNewDnpLinkOutput>, GetNewDnpLinkInput>(`${this.baseUrlZerezesApi}/dnp-link`, input);
        return promise;
    }
}